import {useDispatch} from "react-redux";

import {setInputValueAndRunQuote} from "apps/QuoterApp/reduxElements/slices/quoteRequest";

let setInputPromise;

function useSetQuoteInput() {
    const dispatch = useDispatch();

    return (quoteInput) => {
        setInputPromise && setInputPromise.abort();
        setInputPromise = dispatch(setInputValueAndRunQuote(quoteInput));
    };
}

export default useSetQuoteInput;
